import { useRemoteConfig } from '@funtech-int/yango-shared';

import { remoteConfigScheme } from '@/app/lib/remoteConfig';
import { clientConfig } from '@/config/client';

const { legalLink: defaultLegalLink } = clientConfig;

export const useLegal = () => {
    const remoteConfig = useRemoteConfig(remoteConfigScheme);

    const legal = remoteConfig.get('legal');

    return legal?.find((entry) => entry.id === 'agreement')?.link ?? defaultLegalLink;
};
